import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { from, lastValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return from(
    (async () => {
      const token = authService.getToken();

      const request = token
        ? req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          })
        : req;

      return await lastValueFrom(next(request));
    })(),
  );
};
